import React, { useState } from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { View } from '@uncinc/react-drupal-core';

import Locations from '../../View/Locations';

import './style.scss';

const ParagraphBlockReference = ({ id, entity }) => {
  const block = entity.getIn(['field_block_reference', 0]);
  const blockId = block.get('target_id');
  const [currentPage, setCurrentPage] = useState(1);

  if (!blockId) {
    return null;
  }

  if (/^views_block/.test(blockId)) {
    const [, viewName] = blockId.split('__');
    const viewId = viewName.split('_', viewName.split('_').length - 2).join('_');
    const viewDisplay = viewName.split('_').splice(viewName.split('_').length - 2).join('_');

    if (viewId === 'locations') {
      return (
        <div className="ParagraphBlockReference paragraph paragraph--type--block-reference">
          <Locations page={currentPage + 1} setCurrentPage={setCurrentPage} />
        </div>
      );
    }

    return (
      <div id={id} className="Paragraph ParagraphBlockReference paragraph paragraph--type--block-reference">
        <Container fluid>
          {entity.getIn(['field_title', 0, 'value']) && (
            <div className="paragraph--block-reference--title text-center l-spacing--bottom--medium">
              <h2>
                {entity.getIn(['field_title', 0, 'value'])}
              </h2>
            </div>
          )}
          <View id={viewId} display={viewDisplay} page={currentPage + 1} setCurrentPage={setCurrentPage} />
        </Container>
      </div>
    );
  }

  return <div>{block}</div>;
};

export default ParagraphBlockReference;
